<template>
  <div>
    <h3 class="mb-3">{{title}}</h3>
    <p class="text-muted mb-4" v-html="description"></p>
    <slot name="button-add"></slot>
  </div>
</template>

<script>
  export default {
    name: 'EmptyListView',
    props: {
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      }
    }

  }
</script>
